// for salary details of employee

export const RESET_EDUCATION_INFO = "reset_education_info";
export const EDUCATION_INFO = "education_info";
export const EDUCATION_INFO_SUCCESS = "education_info_success";
export const EDUCATION_INFO_FAILURE = "education_info_failure";
